import React, {useCallback} from 'react';
import clsx from 'clsx';
import StepperContext from '../StepperContext';
import * as PropTypes from 'prop-types';
import {Button} from "presentation/common/components";
import styles from './StepperActions.module.scss';
import {emptyFn} from "presentation/common/helpers/utils";

export const StepperActions = React.forwardRef(function Stepper(props, ref) {

  const {
    onCancel = emptyFn,
    onFinish = emptyFn,
    onBack = emptyFn,
    onFinishDisabled = false,
    onValidateNext,
    finishButtonText,
  } = props;

  const {activeStep, setCurrentStepActive, stepCount} = React.useContext(StepperContext);
  const isLast = activeStep === stepCount;

  const next = async () => {
    if (onValidateNext) {
      const isValid = await onValidateNext();

      if (isValid) {
        setCurrentStepActive(value => value + 1);
      }

      return;
    }

    setCurrentStepActive(value => value + 1);
  };

  const back = useCallback(() => {
    if (onBack) {
      onBack();
    }

    setCurrentStepActive(value => value - 1);
  }, [setCurrentStepActive, onBack]);

  return (
    <div className={clsx("flex justify-end px-3 py-2 lg:px-0", styles.buttonsContainer)}>
      <Button label="Cancelar" onClick={onCancel.bind(activeStep)} theme="outline"/>
      {activeStep !== 1 && <Button label="Anterior" onClick={back} />}
      {isLast
        ? <Button label={finishButtonText} onClick={onFinish} disabled={onFinishDisabled} />
        : <Button label="Siguiente" onClick={next} />}
    </div>
  );
});

StepperActions.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  finishButtonText: PropTypes.string,
  onFinishDisabled: PropTypes.bool,
  onValidateNext: PropTypes.func,
  onCancel: PropTypes.func,
  onFinish: PropTypes.func,
  onBack: PropTypes.func
};

StepperActions.defaultProps = {
  onBack: emptyFn(),
  onCancel: emptyFn(),
}

export default React.memo(StepperActions);
